// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base styles for the middle container */
.middle-container {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 95%;
  
  margin: 20px auto; /* Center the container horizontally */
  display: flex;
  flex-direction: column;
  justify-content: center;

}

/* Top row styles */
.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px; /* Space between control groups */
  margin-bottom: 20px;
}

/* Control group styles */
.control-group {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.control-group label {
  font-size: 16px;
  color: #333333;
  margin-bottom: 5px;
  white-space: nowrap; /* Prevent label from breaking into two lines */
}

.control-group input,
.control-group select {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  width: 200px; /* Adjust width as needed */
}

/* Bottom row styles */
.bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px; /* Space between sections */
}

/* Left section styles */
.left-section {
  display: flex;
  flex-direction: column;
  align-items: center; /* Align items to the left */
  width: 50%;
  font-size: 24px;
}

.upload-btn {
  background-color: #418ff3; /* Replace with your preferred color */
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 4px;
  margin-bottom: 10px;
}

.upload-btn:hover {
  background-color: #3778cc;
}

.crop-image {
  align-self: center;
  max-width: 70%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 10px;
}

.image-name {
  align-self: center;
  margin-top: 5px;
  font-weight: bold;
}

.crop-age{
  margin-top: 5px;
}

.generate-section {
  display: flex;
  align-items: center;
  margin-top: 10px;
  gap: 10px;
}

.crop-age-image {
  margin-right: 10px;
}

.generate-btn {
  background-color: #418ff3; /* Replace with your preferred color */
  color: #ffffff;
  border: none;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 4px;
}

.generate-btn:hover {
  background-color: #3778cc;
}

.generate-btn:disabled {
  background-color: #ccc; /* Gray */
  color: #666;
  cursor: not-allowed;
}

.right-section {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: end;
  width: 50%;
  /* Placeholder styles, adjust as needed */
}

/* Media query for smaller screens */
@media (max-width: 768px) {
  .top-row,
  .bottom-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .control-group input,
  .control-group select {
    width: 100%;
  }

  .left-section,
  .right-section {
    width: 100%;
  }
}
#transplantDate:disabled {
  opacity: 1; /* Ensures it's fully visible */
  cursor: default; /* Keeps the default cursor */
  color: inherit; /* Inherits color from parent */
  background-color: white; /* Inherits background color from parent */
  
  appearance: none; /* Removes default styling */
}
#cropName:disabled {
  opacity: 1; /* Ensures it's fully visible */
  cursor: default; /* Keeps the default cursor */
  color: inherit; /* Inherits color from parent */
  background-color: white; /* Inherits background color from parent */
  
  appearance: none; /* Removes default styling */
}

.loading-spinner {
  align-self: center;
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 1.5s linear infinite;
  margin: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}


.small-loading-spinner {
  align-self: center;
  border: 8px solid #f3f3f3; /* Light grey */
  border-top: 8px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1.5s linear infinite;
  margin-left: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
/* Button container to align buttons to the right */
.button-container {
  display: flex;
  justify-content: flex-end; /* Align items to the right */
  margin-bottom: 20px; /* Add margin to separate from other content */
}

/* Edit button styles */
.edit-btn {
  background-color: #418ff3; /* Preferred color */
  color: #ffffff;
  border: none;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 4px;
 
}
.edit-btn:hover{
  background-color: #3778cc; /* Replace with your preferred color */
}
.edit-btn:disabled {
  background-color: #6c757d; /* Gray color for disabled state */
  color: #ffffff; /* Text color for disabled state */
  cursor: not-allowed; /* Change cursor to indicate disabled state */
  opacity: 0.65; /* Optional: Make the button slightly transparent */
}

.edit-btn:disabled:hover {
  background-color: #6c757d; /* Ensure disabled button color doesn't change on hover */
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.progress-container{
  display: flex;
  flex-direction: row;
}
`, "",{"version":3,"sources":["webpack://./src/styles/middle.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,UAAU;;EAEV,iBAAiB,EAAE,sCAAsC;EACzD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;;AAEzB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS,EAAE,iCAAiC;EAC5C,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB,EAAE,+CAA+C;AACtE;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY,EAAE,2BAA2B;AAC3C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS,EAAE,2BAA2B;AACxC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,4BAA4B;EACjD,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB,EAAE,sCAAsC;EACjE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB,EAAE,SAAS;EACjC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE;;IAEE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,WAAW;EACb;AACF;AACA;EACE,UAAU,EAAE,+BAA+B;EAC3C,eAAe,EAAE,6BAA6B;EAC9C,cAAc,EAAE,+BAA+B;EAC/C,uBAAuB,EAAE,0CAA0C;;EAEnE,gBAAgB,EAAE,4BAA4B;AAChD;AACA;EACE,UAAU,EAAE,+BAA+B;EAC3C,eAAe,EAAE,6BAA6B;EAC9C,cAAc,EAAE,+BAA+B;EAC/C,uBAAuB,EAAE,0CAA0C;;EAEnE,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,SAAS;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;;AAGA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,eAAe;EAC1C,6BAA6B,EAAE,SAAS;EACxC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;AACA,mDAAmD;AACnD;EACE,aAAa;EACb,yBAAyB,EAAE,6BAA6B;EACxD,mBAAmB,EAAE,8CAA8C;AACrE;;AAEA,uBAAuB;AACvB;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,kBAAkB;;AAEpB;AACA;EACE,yBAAyB,EAAE,sCAAsC;AACnE;AACA;EACE,yBAAyB,EAAE,kCAAkC;EAC7D,cAAc,EAAE,kCAAkC;EAClD,mBAAmB,EAAE,6CAA6C;EAClE,aAAa,EAAE,mDAAmD;AACpE;;AAEA;EACE,yBAAyB,EAAE,yDAAyD;AACtF;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["/* Base styles for the middle container */\n.middle-container {\n  background-color: #f5f5f5;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  width: 95%;\n  \n  margin: 20px auto; /* Center the container horizontally */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n}\n\n/* Top row styles */\n.top-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px; /* Space between control groups */\n  margin-bottom: 20px;\n}\n\n/* Control group styles */\n.control-group {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.control-group label {\n  font-size: 16px;\n  color: #333333;\n  margin-bottom: 5px;\n  white-space: nowrap; /* Prevent label from breaking into two lines */\n}\n\n.control-group input,\n.control-group select {\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  width: 200px; /* Adjust width as needed */\n}\n\n/* Bottom row styles */\n.bottom-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px; /* Space between sections */\n}\n\n/* Left section styles */\n.left-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* Align items to the left */\n  width: 50%;\n  font-size: 24px;\n}\n\n.upload-btn {\n  background-color: #418ff3; /* Replace with your preferred color */\n  color: #ffffff;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  border-radius: 4px;\n  margin-bottom: 10px;\n}\n\n.upload-btn:hover {\n  background-color: #3778cc;\n}\n\n.crop-image {\n  align-self: center;\n  max-width: 70%;\n  height: auto;\n  border-radius: 8px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);\n  margin-top: 10px;\n}\n\n.image-name {\n  align-self: center;\n  margin-top: 5px;\n  font-weight: bold;\n}\n\n.crop-age{\n  margin-top: 5px;\n}\n\n.generate-section {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n  gap: 10px;\n}\n\n.crop-age-image {\n  margin-right: 10px;\n}\n\n.generate-btn {\n  background-color: #418ff3; /* Replace with your preferred color */\n  color: #ffffff;\n  border: none;\n  padding: 5px 10px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  border-radius: 4px;\n}\n\n.generate-btn:hover {\n  background-color: #3778cc;\n}\n\n.generate-btn:disabled {\n  background-color: #ccc; /* Gray */\n  color: #666;\n  cursor: not-allowed;\n}\n\n.right-section {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  width: 50%;\n  /* Placeholder styles, adjust as needed */\n}\n\n/* Media query for smaller screens */\n@media (max-width: 768px) {\n  .top-row,\n  .bottom-row {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .control-group input,\n  .control-group select {\n    width: 100%;\n  }\n\n  .left-section,\n  .right-section {\n    width: 100%;\n  }\n}\n#transplantDate:disabled {\n  opacity: 1; /* Ensures it's fully visible */\n  cursor: default; /* Keeps the default cursor */\n  color: inherit; /* Inherits color from parent */\n  background-color: white; /* Inherits background color from parent */\n  \n  appearance: none; /* Removes default styling */\n}\n#cropName:disabled {\n  opacity: 1; /* Ensures it's fully visible */\n  cursor: default; /* Keeps the default cursor */\n  color: inherit; /* Inherits color from parent */\n  background-color: white; /* Inherits background color from parent */\n  \n  appearance: none; /* Removes default styling */\n}\n\n.loading-spinner {\n  align-self: center;\n  border: 8px solid #f3f3f3; /* Light grey */\n  border-top: 8px solid #3498db; /* Blue */\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  animation: spin 1.5s linear infinite;\n  margin: 20px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n\n.small-loading-spinner {\n  align-self: center;\n  border: 8px solid #f3f3f3; /* Light grey */\n  border-top: 8px solid #3498db; /* Blue */\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  animation: spin 1.5s linear infinite;\n  margin-left: 10px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n/* Button container to align buttons to the right */\n.button-container {\n  display: flex;\n  justify-content: flex-end; /* Align items to the right */\n  margin-bottom: 20px; /* Add margin to separate from other content */\n}\n\n/* Edit button styles */\n.edit-btn {\n  background-color: #418ff3; /* Preferred color */\n  color: #ffffff;\n  border: none;\n  padding: 5px 10px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  border-radius: 4px;\n \n}\n.edit-btn:hover{\n  background-color: #3778cc; /* Replace with your preferred color */\n}\n.edit-btn:disabled {\n  background-color: #6c757d; /* Gray color for disabled state */\n  color: #ffffff; /* Text color for disabled state */\n  cursor: not-allowed; /* Change cursor to indicate disabled state */\n  opacity: 0.65; /* Optional: Make the button slightly transparent */\n}\n\n.edit-btn:disabled:hover {\n  background-color: #6c757d; /* Ensure disabled button color doesn't change on hover */\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.progress-container{\n  display: flex;\n  flex-direction: row;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
